export class SearchModel
{
    public search: string;
    
    public constructor()
    {
        
    }
}